import React, { lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "../components/ui/sonner";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ChatWidget from "../components/ChatWidget";
import CookieBanner from "../components/CookieBanner";

const HomePage = lazy(() => import("../pages/HomePage"));
const ApartmentsPage = lazy(() => import("../pages/ApartmentsPage"));
const WohnungenPage = lazy(() => import("../pages/WohnungenPage"));
const ZimmerPage = lazy(() => import("../pages/ZimmerPage"));
const ApartmentDetailPage = lazy(() => import("../pages/ApartmentDetailPage"));
const ApplyPage = lazy(() => import("../pages/ApplyPage"));
const ForCompaniesPage = lazy(() => import("../pages/ForCompaniesPage"));
const ForPropertyManagersPage = lazy(() => import("../pages/ForPropertyManagersPage"));
const AboutPage = lazy(() => import("../pages/AboutPage"));
const ContactPage = lazy(() => import("../pages/ContactPage"));
const ImpressumPage = lazy(() => import("../pages/ImpressumPage"));
const DatenschutzPage = lazy(() => import("../pages/DatenschutzPage"));
const NotFoundPage = lazy(() => import("../pages/NotFoundPage"));
const BlogListPage = lazy(() => import("../pages/BlogListPage"));
const BlogPostPage = lazy(() => import("../pages/BlogPostPage"));

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    // Route changes must jump, not animate (W11); targeted smooth scrolling
    // comes with Motion v2 in R3.
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

export default function AppRouter() {
  const { pathname } = useLocation();
  // Detail pages carry the StickyMobileBar (R1.4); the floating chat toggle
  // would collide with it, so the widget is suppressed there. The check lives
  // here (not in the widget) because AppRouter owns page-shell composition.
  const hideChatWidget = /^\/apartments\/[^/]+$/.test(pathname);

  return (
    <div className="App">
      <ScrollToTop />
      <Header />
      <main>
        <Suspense fallback={<div className="text-center py-20">Loading...</div>}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/apartments" element={<ApartmentsPage />} />
            <Route path="/wohnungen" element={<WohnungenPage />} />
            <Route path="/wohnungen/:city" element={<ApartmentsPage type="apartment" />} />
            <Route path="/zimmer" element={<ZimmerPage />} />
            <Route path="/zimmer/:city" element={<ApartmentsPage type="room" />} />
            <Route path="/apartments/:id" element={<ApartmentDetailPage />} />
            <Route path="/apply/:shortId" element={<ApplyPage />} />
            <Route path="/for-companies" element={<ForCompaniesPage />} />
            <Route path="/for-property-managers" element={<ForPropertyManagersPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/legal" element={<ImpressumPage />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blog/kategorie/:category" element={<BlogListPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/privacy" element={<DatenschutzPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
      <Toaster position="top-center" />
      {!hideChatWidget && <ChatWidget />}
      <CookieBanner />
    </div>
  );
}
